/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { RefSectionsEntitiesFragment, RefSectionsFragment } from "@cosmos/hygraph-schema";

import {
	AccordionFeatureCardsSection,
	AriesCardsSection,
	AssetCarouselSection,
	AssetGallerySection,
	BlogCardsSection,
	CkRichTextSection,
	CommunitySection,
	ComplexCtaCardsSection,
	ContentLargeImageSection,
	ContentSliderAssetSection,
	CruxSection,
	DelphinusCardsGridSection,
	DividerSection,
	DownloadCardsSection,
	DownloadableSection,
	EmbedSection,
	EventsTableSection,
	FAQSearchSection,
	FAQSection,
	FeatureCardsSection,
	FeaturePanelsSection,
	GeminiCardsSection,
	HydrusColumnListSection,
	LatestNewsSection,
	LearnSection,
	LicensesCollapsedSection,
	LogoListSection,
	LogoMultiCardsSection,
	NewsCardsSection,
	NewsMediaCardsSection,
	NewsletterSignup,
	NumberCalloutSection,
	QuoteSection,
	ResellersSearchSection,
	RichTextSection,
	SimpleCtaSection,
	SlimContactCardsSection,
	TabbedBlogCardsSection,
	TabbedContentImageSection,
	TabbedFullWidthAssetSection,
	UTCardsSection,
	BlobTableSection,
	PluginListTableSection,
} from ".";

type SectionType<Section extends { __typename: any }> = {
	[S in Section as S["__typename"]]: any;
};

type RefSectionsEntitiesSection = Exclude<RefSectionsEntitiesFragment["section"], null | undefined>;

export type SectionTypename = keyof SectionType<RefSectionsEntitiesSection>;

export const getSections = (
	sections?: RefSectionsFragment[] | null,
	extraProps?: (__typename: SectionTypename, idx: number) => any,
): (React.JSX.Element | null | undefined)[] => {
	if (!sections || !sections.length) return [];
	return sections.map((refSection, i) => {
		const section = refSection.section;
		if (!section || !section.__typename) return;

		switch (section.__typename) {
			case "CosmosSectionAssetCarousel":
				return <AssetCarouselSection key={`ref-section-asset-carousel-${i}`} {...section} />;
			case "CosmosSectionAssetGallery":
				return <AssetGallerySection key={`ref-section-asset-gallery-${i}`} {...section} />;
			case "CosmosSectionBlogCard":
				return <BlogCardsSection key={`ref-section-blog-card-${i}`} {...section} />;
			case "CosmosSectionCommunity":
				return <CommunitySection key={`ref-section-community-${i}`} {...section} />;
			case "CosmosSectionComplexCtaCard":
				return <ComplexCtaCardsSection key={`ref-section-complex-cta-card-${i}`} {...section} />;
			case "CosmosSectionContentLargeImage": {
				const otherProps = extraProps ? extraProps("CosmosSectionContentLargeImage", i) : {};
				return (
					<ContentLargeImageSection
						key={`ref-section-content-large-image-${i}`}
						{...section}
						sectionIndex={i}
						{...otherProps}
					/>
				);
			}
			case "CosmosSectionCrux":
				return <CruxSection key={`ref-section-crux-${i}`} {...section} />;
			case "CosmosSectionDelphinusCardsGrid":
				return <DelphinusCardsGridSection key={`ref-section-delphinus-cards-grid-${i}`} {...section} />;
			case "CosmosSectionDivider":
				return <DividerSection key={`ref-section-divider-${i}`} {...section} />;
			case "CosmosSectionDownloadable":
				return <DownloadableSection key={`ref-section-downloadable-${i}`} {...section} />;
			case "CosmosSectionDownloadCard":
				return <DownloadCardsSection key={`ref-section-download-card-${i}`} {...section} />;
			case "CosmosSectionEmbed":
				return <EmbedSection key={`ref-section-embed-${i}`} {...section} />;
			case "CosmosSectionEventsTable":
				return <EventsTableSection key={`ref-section-events-table-${i}`} {...section} />;
			case "CosmosSectionFeatureCard":
				return <FeatureCardsSection key={`ref-section-feature-card-${i}`} {...section} />;
			case "CosmosSectionFaq":
				return <FAQSection key={`ref-section-faqs-${i}`} {...section} />;
			case "CosmosSectionGameDevFeatureCard":
				return <FeaturePanelsSection key={`ref-section-feature-panels-${i}`} {...section} />;
			case "CosmosSectionGeminiCard":
				return <GeminiCardsSection key={`ref-section-gemini-cards-${i}`} {...section} />;
			case "CosmosSectionHydrusColumnList":
				return <HydrusColumnListSection key={`ref-section-hydrus-column-list-${i}`} {...section} />;
			case "CosmosSectionLatestNews":
				return <LatestNewsSection key={`ref-section-learn-${i}`} {...section} />;
			case "CosmosSectionLearn":
				return <LearnSection key={`ref-section-learn-${i}`} {...section} />;
			case "CosmosSectionLogoList":
				return <LogoListSection key={`ref-section-logo-list-${i}`} {...section} />;
			case "CosmosSectionLogoMultiCard":
				return <LogoMultiCardsSection key={`logo-multi-card-${i}`} {...section} />;
			case "CosmosSectionNewsCard":
				return <NewsCardsSection key={`ref-section-news-card-${i}`} {...section} sectionIndex={i} />;
			case "CosmosSectionNewsMediaCard":
				return <NewsMediaCardsSection key={`ref-section-news-media-card-${i}`} {...section} />;
			case "CosmosSectionNumberCallout":
				return <NumberCalloutSection key={`ref-section-number-callout-${i}`} {...section} sectionIndex={i} />;
			case "CosmosSectionLicensesCollapsed":
				return <LicensesCollapsedSection key={`ref-section-licenses-collapsed-${i}`} {...section} />;
			case "CosmosSectionAccordionFeatureCard":
				return <AccordionFeatureCardsSection key={`ref-section-accordion-featurecards-${i}`} {...section} />;
			case "CosmosSectionRichText":
				return <RichTextSection key={`ref-section-richtext-${i}`} {...section} />;
			case "CosmosSectionNewsletterSignup":
				return <NewsletterSignup key={`ref-section-newslettersignup-${i}`} {...section} />;
			case "CosmosSectionSimpleCta":
				return <SimpleCtaSection key={`ref-section-simplecta-${i}`} {...section} />;
			case "CosmosSectionSlimContactCard":
				return <SlimContactCardsSection key={`ref-section-slim-contact-cards-${i}`} {...section} />;
			case "CosmosSectionTabbedFullWidthAsset":
				return <TabbedFullWidthAssetSection key={`ref-section-tabbed-full-width-asset-${i}`} {...section} />;
			case "CosmosSectionTabbedBlogCard":
				return <TabbedBlogCardsSection key={`ref-section-tabbed-blog-cards-${i}`} {...section} />;
			case "CosmosSectionTabbedContentImage":
				return <TabbedContentImageSection key={`ref-section-tabbed-content-image-${i}`} {...section} />;
			case "CosmosSectionFaqSearch":
				return <FAQSearchSection key={`ref-section-faq-search-${i}`} {...section} />;
			case "CosmosSectionCkRichText":
				return <CkRichTextSection key={`ref-section-ckrichtext-${i}`} {...section} />;
			case "CosmosSectionAriesCards":
				return <AriesCardsSection key={`ref-section-aries-cards-${i}`} {...section} />;
			case "CosmosSectionContentSliderAsset": {
				const otherProps = extraProps ? extraProps("CosmosSectionContentSliderAsset", i) : {};
				return (
					<ContentSliderAssetSection
						key={`ref-section-content-slider-asset-${i}`}
						{...section}
						sectionIndex={i}
						{...otherProps}
					/>
				);
			}
			case "CosmosSectionQuote":
				return <QuoteSection key={`ref-section-quote-${i}`} {...section} />;
			case "CosmosSectionUtCard":
				return <UTCardsSection key={`ref-section-ut-cards-${i}`} {...section} />;
			case "CosmosSectionResellersSearch":
				return <ResellersSearchSection key={`ref-section-resellers-search-${i}`} {...section} />;
			case "CosmosSectionBlobTable":
				return <BlobTableSection key={`ref-section-blob-table-${i}`} {...section} />;
			case "CosmosSectionPluginListTable":
				return <PluginListTableSection key={`ref-section-plugin-list-table-${i}`} {...section} />;
			default:
				return null;
		}
	});
};
